/**
 * Get the current period string based on frequency
 * Uses America/Chicago timezone (CST/CDT)
 * @param {string} frequency - 'daily', 'weekly', or 'monthly'
 * @returns {string} Period string
 */
export function getCurrentPeriod(frequency) {
  // Get current time in Chicago timezone
  const now = new Date();
  const chicagoTime = new Date(now.toLocaleString('en-US', { timeZone: 'America/Chicago' }));
  const year = chicagoTime.getFullYear();

  switch (frequency) {
    case 'daily': {
      const month = (chicagoTime.getMonth() + 1).toString().padStart(2, '0');
      const day = chicagoTime.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`; // YYYY-MM-DD
    }

    case 'weekly': {
      const week = getISOWeek(chicagoTime).toString().padStart(2, '0');
      return `${year}-W${week}`; // YYYY-WXX
    }

    case 'monthly': {
      const month = (chicagoTime.getMonth() + 1).toString().padStart(2, '0');
      return `${year}-${month}`; // YYYY-MM
    }

    default:
      return getCurrentPeriod('daily');
  }
}

/**
 * Calculate ISO week number (Monday = start of week)
 * @param {Date} date
 * @returns {number} Week number (1-53)
 */
function getISOWeek(date) {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  // Set to Thursday of current week (ISO week date system)
  d.setDate(d.getDate() + 4 - (d.getDay() || 7));
  const yearStart = new Date(d.getFullYear(), 0, 1);
  return Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
}

/**
 * Check if a checkoff is current (matches current period)
 * @param {string} checkoffPeriod - Stored period string
 * @param {string} frequency - 'daily', 'weekly', or 'monthly'
 * @returns {boolean}
 */
export function isCurrentPeriod(checkoffPeriod, frequency) {
  return checkoffPeriod === getCurrentPeriod(frequency);
}
